import React from "react";
import path from "path";
import { Link, withRouter } from "react-router-dom";

import ReactMarkdown from "react-markdown";
import { withStyles } from "@material-ui/core/styles";

import { ListItem } from "../components";
import { Heading5, Paragraph } from "../styleguide";

const styles = (theme) => ({
    paragraphStyle: {
        marginBottom: 1,
    },
    listStyle: {
        paddingLeft: 0,
        margin: 0,
    },
    linkStyle: {
        fontFamily: "Arial-BoldMT, Arial, sans-serif",
        fontWeight: "bold",
        color: "#838a92",
        textDecoration: "none",
    },
    headingStyle: {
        marginTop: "15px",
        marginBottom: "4px",
    },
    imageStyle: {
        maxWidth: "100%",
        height: "auto",
    },
});

const LinkRenderer = withRouter(({ href, children, location, client, classes: { linkStyle } }) => {
    if (href.startsWith("http")) {
        return (
            <a className={linkStyle} href={href} target="_blank">
                {children}
            </a>
        );
    }

    // TODO: define url structure / link logic
    if (href.indexOf("#") === 0) {
        return (
            <a
                className={linkStyle}
                href={href}
                onClick={(e) => {
                    e.preventDefault();
                    window.location = href;
                }}
            >
                {children}
            </a>
        );
    }

    const { pathname } = location;

    const [pageType, vehiclePath] = pathname.split("/").slice(1);
    const targetPath = path.join("/", pageType, vehiclePath || "", href);

    return (
        <Link className={linkStyle} to={targetPath}>
            {children}
        </Link>
    );
});

const LinkRendererWithStyles = withStyles(styles)(LinkRenderer);

const ParagraphRenderer = withStyles(styles)(({ children, classes: { paragraphStyle } }) => (
    <Paragraph extraLineHeight className={paragraphStyle}>
        {children}
    </Paragraph>
));

const ListRenderer = withStyles(styles)(({ children, classes: { listStyle } }) => (
    <ul className={listStyle}>{children}</ul>
));

const HeadingRenderer = withStyles(styles)(({ children, classes: { headingStyle } }) => (
    <Heading5 className={headingStyle}>{children}</Heading5>
));

const ImageRenderer = withStyles(styles)(({ src, classes: { imageStyle } }) => (
    <img src={src} alt={src} className={imageStyle} />
));

const Markdown = ({ source, renderers }) => {
    if (!source) {
        return null;
    }

    const defaultRenderes = {
        paragraph: ParagraphRenderer,
        link: LinkRendererWithStyles,
        list: ListRenderer,
        listItem: ListItem,
        heading: HeadingRenderer,
        image: ImageRenderer,
    };

    const mergedRenderers = {
        ...defaultRenderes,
        ...renderers,
    };

    return (
        <ReactMarkdown
            source={source}
            renderers={mergedRenderers}
            escapeHtml={false}
            allowedTypes={[
                "root",
                "break",
                "paragraph",
                "emphasis",
                "strong",
                "thematicBreak",
                "link",
                "linkReference",
                "list",
                "listItem",
                "heading",
                "html",
                "image",
            ]}
        />
    );
};

export default Markdown;



// WEBPACK FOOTER //
// ./src/components/Markdown.js